import { getCookie } from 'cookies-next';

import { getVideoType } from '@sola/utils/video.js';

import { oneTrust } from './consent';

export const cookieFree = (
  getOptanonConsent?: string,
  getOptanonAlertBoxClosed?: string,
) => {
  if (getOptanonAlertBoxClosed) {
    if (
      !getOptanonConsent?.includes(oneTrust.targetingCookiesOptOut) &&
      !getOptanonConsent?.includes(oneTrust.peformanceCookiesOptOut)
    ) {
      return false;
    }
  }
  if (!getOptanonAlertBoxClosed) {
    return false;
  }
  return true;
};

export const cookielessVideoString = (video: string) => {
  let videoString = video;
  const videoType = getVideoType(video);
  if (videoType === 'youtube') {
    videoString = videoString.replace('https://', '').replace('www.', '');
    videoString = videoString.replace(
      'youtube.com/watch?v=',
      'https://www.youtube-nocookie.com/embed/',
    );
    videoString = videoString.replace(
      'youtu.be/',
      'https://www.youtube-nocookie.com/embed/',
    );
    videoString = videoString.replace(
      'youtube.com/embed/',
      'https://www.youtube-nocookie.com/embed/',
    );
    return videoString;
  }
  if (videoType === 'vimeo') {
    if (videoString.includes('?')) {
      videoString += '&DNT=true';
    } else {
      videoString += '?DNT=true';
    }
    return videoString;
  }
  return videoString;
};

export const cookieConsentVideoURL = (video: string) => {
  let videoString = video;
  const requireCookieLessEmbed = cookieFree(
    getCookie('OptanonConsent'),
    getCookie('OptanonAlertBoxClosed'),
  );
  if (requireCookieLessEmbed === false) {
    return videoString;
  }

  videoString = cookielessVideoString(videoString);

  return videoString;
};
